import {
  DesignChannelType,
  DesignChannelName
} from '../../types';

/**
 * Maps values from @see DesignChannelName to their matching values in @see DesignChannelType.
 *
 * Ideally we would get rid of @see DesignChannelName which makes this unnecessary, but that would require changes in PE as well.
 */
export const channelNameToType: {
  [K in keyof(typeof DesignChannelType) as (typeof DesignChannelName)[K]]: (typeof DesignChannelType)[K];
} = {
  [DesignChannelName.email]: DesignChannelType.email,
  [DesignChannelName.facebook]: DesignChannelType.facebook,
  [DesignChannelName.instagram]: DesignChannelType.instagram,
  [DesignChannelName.mobile]: DesignChannelType.mobile,
  [DesignChannelName.other]: DesignChannelType.other,
  [DesignChannelName.sms]: DesignChannelType.sms,
  [DesignChannelName.socialChat]: DesignChannelType.socialChat,
  [DesignChannelName.twitter]: DesignChannelType.twitter,
  [DesignChannelName.voice]: DesignChannelType.voice,
  [DesignChannelName.webChat]: DesignChannelType.webChat,
  [DesignChannelName.whatsApp]: DesignChannelType.whatsApp
};
